module.exports = __webpack_public_path__ + "static/media/filter-icon.71d211d9.svg";